import {Link, useNavigate, useRouteError} from "react-router-dom";
import {PageTitles, SitePages} from "../SitePages";
import {useTitle} from "../hooks/UseTitle";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);
    
    useTitle(PageTitles.Error)
    
    return (
        <div id="error-page">
        <h1>    
            <Link to={SitePages.FrontPage}>How about you go somewhere you're meant to be</Link>
            <p> 
                Link pointing to {SitePages.FrontPage}
            </p>
            <p>
                Error: {error.message}    
            </p>
        </h1>
        </div>
    );
}